import { useBusiness } from '../../../context/BusinessContext'
import { BusinessType } from './BusinessDetail'
import Tooltip from '../../../components/common/Tooltip'
import { FaCheck } from 'react-icons/fa'
import { IoMdCheckmark } from 'react-icons/io'
import { IoIosCheckmark } from 'react-icons/io'
import { FaCircle } from 'react-icons/fa'
import { useState } from 'react'
import { Check, Kanban } from 'lucide-react'
import Notify from '../../../components/common/Notify'

const BusinessTimeLineSteps = ({ data }: { data: BusinessType }) => {
    const { business, currentTab, moveBusiness } = useBusiness()
    const pipeIndex = business.pipelines.findIndex((pipeline: any) => pipeline.value === currentTab)
    const allTasks = business.pipelines[pipeIndex].steps.flatMap((step: any) => step.business || []) // Lista com apenas as tasks de todas as etapas do pipeline
    const steps = business.pipelines[pipeIndex].steps
    const initialStepIndex = steps.findIndex((step: any) => step.id == data.step.id)
    const [stepIndex, setStepIndex] = useState(initialStepIndex)
    const percentage = (stepIndex * 100) / (steps.length - 1)

    const handleChangeStep = (step: any, index: number) => {
        const id = data.id //
        if (!data.id || !id) return

        const updatedTasks = allTasks.map(task => {
            if (task.id == id) {
                return { ...task, stepID: step.id }
            } else {
                return { ...task, stepID: task.stepID }
            }
        })

        //* Atualiza banco de dados e contexto
        moveBusiness(parseInt(data.id), currentTab, parseInt(step.id), updatedTasks)
        setStepIndex(index)
    }

    return (
        <div className='relative flex items-center w-full mt-4'>
            {/* Linha Horizontal */}
            <div className='absolute top-1/2 w-full border-t-[2px] border-gray-300'>
                <div className='absolute -top-[2px] left-0 h-[2px] bg-green-500' style={{ width: `${percentage}%` }} />
            </div>

            <div className='relative flex justify-between w-full'>
                {steps.map((step: any, index: number) => (
                    <div key={index} className={`relative flex justify-center w-1/${steps.length}`}>
                        {/* Bullets */}
                        <Tooltip
                            label={`${index === stepIndex ? 'Fase atual' : `Enviar para ${step.title}`}`}
                            placement={index === 0 ? 'bottomright' : 'bottomleft'}
                        >
                            <div
                                onClick={() => {
                                    if (index === stepIndex) return
                                    handleChangeStep(step, index)
                                }}
                                className={`w-6 h-6 relative top-1 rounded-full border-2 shadow-lg bg-white dark:bg-gray-800 flex items-center justify-center ${
                                    index <= stepIndex
                                        ? 'border-brand-500 dark:border-brand-500'
                                        : ' border-gray-300 dark:border-gray-300'
                                } ${index !== stepIndex && 'cursor-pointer'}`}
                            >
                                {index <= stepIndex ? (
                                    <IoIosCheckmark className='text-brand-500 w-5 h-5' />
                                ) : (
                                    <FaCircle className='text-gray-300 w-2 h-2' />
                                )}
                            </div>
                        </Tooltip>
                        {/* Label da etapa */}
                        <p
                            className={`hidden md:flex absolute text-xs -top-3 whitespace-nowrap items-center gap-1 ${
                                index === steps.length - 1 ? 'right-5' : 'left-5'
                            } ${index === stepIndex && 'text-brand-500 font-semibold rounded-full'} `}
                        >
                            <Kanban className='w-5 h-5' style={{ color: step.color }} />
                            {step.title}
                            {index === stepIndex && <Notify right='-right-4' />}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default BusinessTimeLineSteps
